// OUTSYS_Headless.tsx
import * as React from "react";
import "./index.css"

// onChange: The update function for the main control.
const OUTSYS_Headless = ({ objNames, onChange }: any) => {
  // If the input changes, then change the parent model.
  React.useEffect(() => {
    onChange({name: 'objNames', value: objNames })
  }, [])

  return(<></>)
}
 
export {OUTSYS_Headless};